import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import {toastInfo} from "../../../js/toast";
import {FieldArray, Form, Formik} from 'formik';
import {useNavigate, useParams} from "react-router-dom";
import {LoaderEllipsisComponent} from "../../../components/elements/Loader/LoaderComponent";
import {PrimaryButton, SecondaryButton} from "../../../components/elements/Inputs/ButtonsComponents";
import {SelectComponent} from "../../../components/elements/Inputs/SelectComponent";
import {TransferDetails} from "./DetailTransferComponent";
import api from "../../../js/api";
import {Card, Typography} from "@material-tailwind/react";
import {ModalComponent} from "../../../components/elements/Modal/ModalComponent";


export function CreateTransfer(props) {
  const {loader} = props;

  const nav = useNavigate();
  const {id} = useParams();

  const handleSubmit = (formValue) => {
    if (id) {
    } else {
      console.log(formValue)
      let hassError = false;
      formValue.transfer_detail.map((valor)=>{
        if(valor.quantity > valor.product_presentation?.inventario?.quantity){
          hassError = true
        }
      })

      if(!hassError){
        props.create(formValue, nav)
      } else {
        toastInfo(`Verifique que no exista error en algun campo del formulario`)
      }
    }
  }

  return (
    <>
      <Card className="py-5 h-full px-4 w-full border shadow-lg">
        <div className="w-full h-full">
          <LoaderEllipsisComponent loader={loader}/>
          <FormItemPurchaseSearch handleSubmit={handleSubmit}/>
        </div>
      </Card>
    </>
  )
}

const ButtonsForm = ({goBack, isView, isUpdate, submitForm, isValid}) => {

  return (
    <div className="flex md:flex-row lg:flex-row flex-col justify-center gap-x-12 mt-8">
      <SecondaryButton
        type="button"
        text={'Regresar'}
        onClick={goBack}
      >
      </SecondaryButton>
      {
        !isView &&
        <PrimaryButton
          onClick={submitForm}
          text={isUpdate ? 'Actualizar' : 'Crear'}
          disabled={!isValid}
        >
        </PrimaryButton>
      }
    </div>
  )
}

const FormItemPurchaseSearch = ({handleSubmit}) => {
  const [didMount, setMount] = useState(false);
  const [openModalBack, setOpenModalBack] = useState(false);
  const [warehouse, setWarehouse] = useState(false);
  const [warehouseOrigenSelected, setWOSelected] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    setMount(true);
  }, []);

  useEffect(() => {
    if (didMount) {
      api.get('warehouse/options')
        .then((response) => {
          setWarehouse(response.data)
        })
        .finally(() => {
        })
    }
  }, [didMount]);

  useEffect(() => {
    setMount(true)
  }, [])

  const validationSchemaSearch = Yup.object().shape({
    warehouse_origen: Yup.number().required('Requerido'),
    warehouse_destino: Yup.number().required('Requerido')
      .test('noIgual', 'Los campos Sucursal origen y Sucursal destino no deben tener el mismo valor',
        function (value) {
        return value !== this.parent.warehouse_origen;
      }),
    transfer_detail: Yup.array()
      .of(
        Yup.object().shape({
          product_presentation: Yup.object().required('Requerido'),
          quantity: Yup.number().required('Requerido'),
        })
      )
      .min(1, 'Mínimo un detalle')
      .required('Debe generar un detalle') // these constraints are shown if and only if inner constraints are satisfied
    ,
  });

  const loadOptions = async (inputValue, didMountComponent) => {
    // Realziamos la llamada a la API para obtener opciones pasandole el valor del input como parámetro
    const params = {
      name: inputValue,
      warehouse_id: warehouseOrigenSelected,
    }
    if (didMountComponent) {
      const response = await api.get('product-presentation/search', params)
      return response.data
    }
  };

  const callbackOnChangeWarehouseOrigen = (optionSelect)=>{
    setWOSelected(optionSelect)
  }


  return (

    <Formik
      validationSchema={validationSchemaSearch}
      onSubmit={handleSubmit}
      validateOnMount={true}
      initialValues={{transfer_detail: [{}]}}
      component={({values, isValid, errors, touched}) =>
        <Form
          name="formTransfer">
          <div className="xl:lg:2xl:md:w-[70%] w-full mx-auto py-4 ">
            <Typography className="font-bold text-black mb-4" variant="h4">
              Transeferir Productos
            </Typography>
            <div className="space-y-4 shadow-gray-400 shadow px-4 py-6 h-fit">
              <SelectComponent
                name='warehouse_origen'
                callbackOnChange={callbackOnChangeWarehouseOrigen}
                label='Sucursal Origen'
                options={warehouse}
              />
              <SelectComponent
                name='warehouse_destino'
                label='Sucursal Destino'
                options={warehouse}
              />
            </div>
            {/*=========================================================================================*/}
            {/*=========================================================================================*/}
            {/*=========================================================================================*/}
            <FieldArray
              name="transfer_detail"
              validateOnChange={true}
              render={(helpers) =>
                <TransferDetails
                {...helpers}
                values={values}
                errors={errors}
                touched={touched}
                warehouse={warehouse}
                searchProduct={loadOptions}
               />}
            />
            <ButtonsForm
              isUpdate={false}
              isView={false}
              isValid={isValid}
              goBack={()=>setOpenModalBack(true)}
              submitForm={()=>{}}
            />
          </div>
          <ModalComponent
            show={openModalBack}
            setShow={()=>setOpenModalBack(!openModalBack)}
            title={'Regresar a Lista de compras'}
            message={'¿Está seguro que desea salir de la vista Transeferir Productos?, los datos ingresados se perderan.'}
            labelButtonConfirm="Si, salir"
            onConfirm={() => {
              nav('/transfer')
              setOpenModalBack(!openModalBack)
            }}
          />
        </Form>
      }
    />

  )
}
